import { Tree } from './utils/get-branch';
import type { OptionIDs } from '.';

const decisionTree: Tree<OptionIDs> = {
  branches: [
    {
      branches: [
        {
          content: {
            scrollTo: 'Get in touch about joining',
            title: 'Looking to join',
          },
          id: 'lookingToJoin',
        },
        {
          branches: [
            {
              content: {
                scrollTo: 'Extras',
                title: 'Extras and claiming',
              },
              id: 'extrasAndClaiming',
            },
            {
              content: {
                scrollTo: 'Hospital',
                title: 'Hospital',
              },
              id: 'hospital',
            },
            {
              content: {
                scrollTo: 'My account',
                title: 'My account',
              },
              id: 'myAccount',
            },
            {
              content: {
                scrollTo: 'Change cover',
                title: 'Change cover',
              },
              id: 'changeCover',
            },
            {
              content: {
                scrollTo: 'Something else',
                title: 'Something else',
              },
              id: 'somethingElse',
            },
          ],
          content: {
            branchHeading: 'My query is about …',
            scrollTo: 'My query is about …',
            title: 'Current member',
          },
          id: 'currentMember',
        },
      ],
      content: {
        branchHeading: 'About me …',
        scrollTo: 'About me …',
        title: 'Health insurance',
      },
      id: 'healthInsurance',
    },
    {
      content: {
        scrollTo: 'Get in touch',
        title: 'Other insurance',
      },
      id: 'otherInsurance',
    },
  ],
  content: {
    branchHeading: 'What can we help with?',
    title: 'Decision Tree',
  },
  id: 'root',
};

export default decisionTree;
